import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "checkbox-group"
}
const _hoisted_2 = {
  key: 2,
  class: "text-body-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_ontos_colored_entry_list = _resolveComponent("ontos-colored-entry-list")!

  return (_openBlock(), _createBlock(_component_ontos_colored_entry_list, {
    ref: "list",
    entries: _ctx.states,
    form: "dot",
    reorderable: "",
    "automatic-color": "",
    min: 2,
    "colors-of": _ctx.colorsOf,
    normalize: _ctx.normalizeStates,
    columns: _ctx.columns,
    "create-label": _ctx.$tt('state-create')
  }, _createSlots({
    "cell-flags": _withCtx(({entry, entries, set, commit, editable}) => [
      (editable && _ctx.$vuetify.display.xs)
        ? (_openBlock(), _createBlock(_component_v_select, {
            key: 0,
            items: _ctx.flagItems,
            "model-value": _ctx.flagOf(entry, 'initial'),
            disabled: !!entry.initial,
            density: "compact",
            variant: "underlined",
            "hide-details": "",
            "onUpdate:modelValue": ($event: any) => (_ctx.setFlag(entry, entries, set, commit, $event))
          }, null, 8, ["items", "model-value", "disabled", "onUpdate:modelValue"]))
        : editable
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_v_checkbox, {
                density: "compact",
                "hide-details": "",
                label: _ctx.$tt('state-initial'),
                "model-value": entry.initial,
                disabled: !!entry.final || !!entry.initial,
                "onUpdate:modelValue": ($event: any) => (_ctx.setInitial(entry, entries, commit))
              }, null, 8, ["label", "model-value", "disabled", "onUpdate:modelValue"]),
              _createVNode(_component_v_checkbox, {
                density: "compact",
                "hide-details": "",
                label: _ctx.$tt('state-final'),
                "model-value": entry.final,
                disabled: !!entry.initial,
                "onUpdate:modelValue": ($event: any) => (set('final', !!$event))
              }, null, 8, ["label", "model-value", "disabled", "onUpdate:modelValue"])
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.flagLabel(_ctx.flagOf(entry))), 1))
    ]),
    _: 2
  }, [
    (_ctx.$slots.subtitle)
      ? {
          name: "subtitle",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "subtitle", {}, undefined, true)
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.$slots.actions)
      ? {
          name: "actions",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "actions", {}, undefined, true)
          ]),
          key: "1"
        }
      : undefined
  ]), 1032, ["entries", "colors-of", "normalize", "columns", "create-label"]))
}